export default __webpack_public_path__ + "static/media/guide37.75cf12cb.png";